import { Directive, ElementRef, Input, HostListener, AfterViewChecked } from '@angular/core';

@Directive({
  selector: '[appBlockingScreen]',
})
export class BlockingScreenDirective implements AfterViewChecked {

  constructor(private el: ElementRef) {
    let root =  this.el.nativeElement;
  }
  enabled:boolean;
  @Input('appBlockingScreen')
    set blockEnabled(enable: boolean){
      this.enabled = enable;
      this.display(enable)
    }
    get blockEnabled():boolean{return this.enabled;}


  private display(display:boolean) {
    let root =  this.el.nativeElement;
    root.style.display = display?'block':'none';
    let nextElement = root.nextElementSibling;
    //let cStyle = root.ownerDocument.defaultView.getComputedStyle(nextElement,null);
    if(display && this.lastScrollHeight !== nextElement.scrollHeight && this.lastScrollWidth !== nextElement.scrollWidth){
      this.lastScrollHeight = nextElement.scrollHeight;
      this.lastScrollWidth = nextElement.scrollWidth;

      root.style.height = this.lastScrollHeight.toString() + "px";
      root.style.width = this.lastScrollWidth.toString() + "px";
      //console.log("updating BlockingScreenDirective")

      // root.style.height = cStyle.height;
      // root.style.width = cStyle.width;

    }
    else{
      this.lastScrollHeight = 0;
      this.lastScrollWidth = 0;
    }
  }
  lastScrollHeight:number=0;
  lastScrollWidth:number=0;

  @HostListener('window:resize', ['$event'])
  onResize(event){
    this.display(this.enabled);
  }
  ngAfterViewChecked(){
    this.display(this.enabled);
  }
  // @HostListener('window:click', ['$event'])
  // onclick(event){
  //   console.log(event);
  //   event.cancelBubble  = true;
  //   return true;
  // }
  // @HostListener('click', ['$event'])
  // onclickclick(event){
  //   console.log(event);
  //   event.cancelBubble  = true;
  //   return true;
  // }

}
